// WhatsApp link used by every "Solicitar orçamento" button
export const WHATSAPP_URL = "https://contate.me/5545991575982";
